import { useState } from 'react';
import Navbar from './components/Navbar';
import Home     from './pages/Home';
import Services from './pages/Services';
import About    from './pages/About';
import Contact  from './pages/Contact';
import './index.css';

// ── PAGE REGISTRY ──────────────────────────────────────────────
// Add new pages here
const PAGES = {
  home:     Home,
  services: Services,
  about:    About,
  contact:  Contact,
};

export default function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const navigate = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const PageComponent = PAGES[currentPage] || Home;

  return (
    <>
      <Navbar currentPage={currentPage} navigate={navigate} />
      <div style={{ paddingTop: 68 }}>
        <PageComponent navigate={navigate} />
      </div>
    </>
  );
}
